(() => {
  if (customElements.get('jfab-personalized-sign')) return;
  class JFabPersonalizedSign extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.variant = this.form.querySelector('[data-sign-variant]');
      this.button = this.form.querySelector('[data-sign-submit]');
      this.price = this.form.querySelector('[data-sign-price]');
      this.review = this.form.querySelector('[data-sign-order-review]');
      this.form.addEventListener('input', () => { this.validateNames(); this.updateReview(); }, options);
      this.form.addEventListener('change', () => { this.updateVariant(); this.updateReview(); }, options);
      this.form.addEventListener('submit', event => {
        this.validateNames();
        this.updateVariant();
        if (!this.canPurchase() || !this.form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, {capture: true, signal: this.events.signal});
      this.updateVariant();
      this.updateReview();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
    canPurchase() {
      const selected = this.variant?.selectedOptions[0];
      return this.dataset.purchaseReady === 'true' && selected?.dataset.available === 'true' && selected?.dataset.positivePrice === 'true';
    }
    updateVariant() {
      const selected = this.variant?.selectedOptions[0];
      if (this.price) this.price.textContent = selected?.dataset.positivePrice === 'true' ? selected.dataset.price : this.dataset.pricePending;
      if (!this.button) return;
      this.button.disabled = !this.canPurchase();
      this.button.textContent = this.dataset.purchaseReady !== 'true' || selected?.dataset.positivePrice !== 'true' ? this.dataset.unavailable : selected?.dataset.available === 'true' ? this.dataset.add : this.dataset.soldOut;
    }
    validateNames() {
      this.form.querySelectorAll('[data-sign-text]').forEach(input => input.setCustomValidity(input.value.trim() ? '' : this.dataset.invalidName));
    }
    updateReview() {
      if (!this.review) return;
      const fragment = document.createDocumentFragment();
      this.form.querySelectorAll('[name^="properties["]').forEach(input => {
        const term = document.createElement('dt');
        const value = document.createElement('dd');
        term.textContent = input.name.slice(11, -1);
        value.textContent = (input.type === 'file' ? input.files?.[0]?.name : input.value) || this.dataset.notEntered;
        fragment.append(term, value);
      });
      this.review.replaceChildren(fragment);
    }
  }
  customElements.define('jfab-personalized-sign', JFabPersonalizedSign);
})();